console.log('MAIN JS')

import "./offscreen-canvas-polyfill.js";
import "./dymo3.js";
import Vue from "vue";
import App from "./App.vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./styles/main.scss";
//import "normalize.css";
import "./vee-validate";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "./router";
import apiConfig from "../api_config.json";

Vue.prototype.$dymo = window.dymo;

axios.defaults.baseURL = apiConfig.baseUrl;
window.IS_KIOSK = window.location.hostname.includes("kiosk.") || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.dymoPrinter) ; // || true; // HACK FOR TESTING

if (window.IS_KIOSK) {
  axios.defaults.headers.common["X-KIOSK"] = true;
}
// Get around Safari bug where it response with 304 (from memory cache) instead of making AJAX GET 
// requests.  We need the GET request to return different items each time its called
// as the server side may have updated.
axios.defaults.headers.common["cache-control"] = "no-cache";

Vue.use(VueAxios, axios);
Vue.use(ElementUI);


String.prototype.replaceAll = function(search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, "g"), replacement);
};

Vue.filter("nl2br", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.replaceAll("\n", "<br />");
});

Vue.config.productionTip = false;

Vue.filter("encode", function(value) {
  return encodeURI(value);
});

import FlashMessage from "@smartweb/vue-flash-message";
import './registerServiceWorker'
Vue.use(FlashMessage);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

